import React, { Component } from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import { withRouter, Link } from "react-router-dom";
import ContentLoader from 'react-content-loader'

/**
 * Learn & Practise card on the NEET/JEE home: the five least accurate chapters
 * of the selected subject. Each row starts practice for that chapter.
 *
 * Reads getSubjects from props, not from its own query.
 *
 * StudentHomeSection has always passed `getSubjects={this.props.getSubjects}`
 * down to this component, but it also carried its own
 * `graphql(FETCH_GET_SUBJECTS, { name: "getSubjects" })`. react-apollo spreads
 * the HOC's data prop *after* ownProps, so the prop was silently shadowed and
 * thrown away — and /student/home, the busiest route in the app, fired two
 * simultaneous `no-cache` getSubjects requests with identical variables.
 *
 * The only field this needs that the page did not already select is
 * studentChapters.accuracy, which StudentHome.jsx now requests.
 */
class PracticeCard extends Component {
    idFunction(data) {
        return parseInt(data + 1);
    }

    leastChapter() {
        const getData = this.props.getSubjects[this.props.stateData.mainindex];
        const subjectClass = { 1: "botany", 2: "physics", 3: "chemistry", 4: "maths", 5: "zoology" }[getData.id] || "";
        return `learn_practice border-0 h-100 ${subjectClass}`;
    }

    render() {
        // The prop is StudentHome's `state.getSubjects` — a plain array of
        // subjects, NOT an Apollo HOC result. StudentHome only renders
        // StudentHomeSection once `state.getSubjects.length > 0`; the guard
        // below is for a student with no subjects yet.
        const getSubjects = this.props.getSubjects;
        if (!getSubjects || getSubjects.length === 0) {
            return (<Card className="learn_practice border-0">
                <div className="showcase-component">
                    <ContentLoader
                        speed={2}
                        width={400}
                        height={560}
                        viewBox="0 0 420 560"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                    >
                        <rect x="8" y="4" rx="2" ry="2" width="400" height="560" />
                    </ContentLoader>
                </div>
            </Card>)
        }

        const singleSubject = getSubjects.find((a) => a.id == this.props.getChapters.id);
        const chapters = this.props.getChapters.studentChapters
            .map((smap) => {
                const singlechap = singleSubject && singleSubject.studentChapters.find((a) => a.id == smap.id);
                return singlechap != undefined ? { ...smap, accuracy: singlechap.accuracy } : undefined;
            })
            .filter(Boolean)
            .sort((a, b) => a.accuracy - b.accuracy)
            .slice(0, 5);

        return (
            <Card className={this.leastChapter()}>
                <Card.Header className="d-flex align-items-center border-0">
                    <div className="icon d-flex align-items-center justify-content-center mr-3">
                        <i className="fa-2x fad fa-book-open" />
                    </div>
                    <div className="header-text">
                        <Card.Title className="h6">Learn &amp; Practise</Card.Title>
                        <Card.Subtitle>Least 5 Accurate Chapters</Card.Subtitle>
                    </div>
                    <Link to="/student/learn-practice" className="view-all ml-auto">
                        View All <i className="far fa-arrow-right ml-1" />
                    </Link>
                </Card.Header>
                <Card.Body>
                    <ul className="list-unstyled learn_practice_lists m-0">
                        {chapters.map((item1, index1) => (
                            <li
                                key={item1.id}
                                className="singleTopic"
                                role="button"
                                onClick={() =>
                                    this.props.practceRedirect(
                                        item1,
                                        this.props.isuserValid.lp_practice_exam
                                    )
                                }
                            >
                                <Row>
                                    <Col xs={8}>
                                        <Row className="topic-content">
                                            <Col xs={3}><div className="sno">{this.idFunction(index1)}</div></Col>
                                            <Col xs={9} className="content">
                                                <div className="content-title mb-1">{item1.chapter}</div>
                                                <div className="content-description">Start Practice Now</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={4}>
                                        {item1.accuracy != "0" ? (
                                            <div className="accurancy"><strong>{item1.accuracy}%</strong><br />accurancy</div>
                                        ) : (<div className="status">Yet to Start</div>)}
                                    </Col>
                                </Row>
                            </li>
                        ))}
                    </ul>
                </Card.Body>
            </Card>
        )
    }
}

export default withRouter(PracticeCard);
